export default __webpack_public_path__ + "static/media/bg.4584e430.webp";